import { render, staticRenderFns } from "./aufgaben_alle.vue?vue&type=template&id=6b4f4f75&scoped=true"
import script from "./aufgaben_alle.vue?vue&type=script&lang=js"
export * from "./aufgaben_alle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4f4f75",
  null
  
)

export default component.exports